const endPoint =
"https://belinda-xflix-backend.onrender.com/v1/videos";
export default endPoint;